import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import s from './Gallery.module.scss';
import Image from '../Images/Images';
// import { PromiseProvider } from 'mongoose';
function Gallery({ url, urlImageSecond, title, isShowText }) {
    return (_jsx(_Fragment, { children: _jsxs("ul", Object.assign({ className: s.imageList }, { children: [_jsx("li", Object.assign({ className: s.imageItem }, { children: _jsx(Image, { src: url, alt: title, className: s.image }) })), isShowText && (_jsx("li", Object.assign({ className: s.imageItem }, { children: _jsx(Image, { src: urlImageSecond, alt: title, className: s.image }) })))] })) }));
}
export default Gallery;
